import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import trim from 'lodash/trim'
import { Typography } from '@material-ui/core'

export const PHYSICAL_ATTRIBUTES = {
    AMOUNT: {
        name: 'amount',
        descriptor: {
            isRequired: true,
            min: 10,
            max: 500,
        },
    },
    NAME_ON_CARD: {
        name: 'nameOnCard',
        descriptor: {
            isRequired: true,
            format: '^.+$',
            min: 1,
            max: 20,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_247/v1622813772/GCG/smb_assets/gcg_reward_card_example_p2ixdt',
        infoText: (
            <>
                <Typography>
                    This is a customizable Name that is printed on the card
                    above the Card Message field. This field does not have to be
                    a name.
                </Typography>
                <br />
                <Typography>
                    This field is required and can be up to 20 characters long.
                </Typography>
            </>
        ),
    },
    CARD_MESSAGE: {
        name: 'cardMessage',
        descriptor: {
            isRequired: true,
            format: '^.+$',
            min: 2,
            max: 20,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_247/v1622813772/GCG/smb_assets/gcg_reward_card_example_p2ixdt',
        infoText: (
            <>
                <Typography>
                    This is a customizable message that is printed on the card
                    below the Name On Card field.
                </Typography>
                <br />
                <Typography>
                    This field is required and can be up to 20 characters long.
                </Typography>
            </>
        ),
    },
    CARRIER_TO: {
        name: 'carrierTo',
        descriptor: {
            isRequired: true,
            format: '^.+$',
            min: 1,
            max: 50,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_484/v1622813476/GCG/smb_assets/gcg_carrier_example_fukmht',
        infoText: (
            <>
                <Typography>
                    The carrier is the sheet of paper that the card is affixed
                    to. It contains information on how to activate and use the
                    attached card.
                </Typography>
                <br />
                <Typography>
                    On the carrier, you can specify the “To:” field so the
                    recipient knows who it is for. In most cases, this will
                    match the Name On Card field, but it doesn’t have to -
                    you’re free to put an appropriate value here to meet your
                    needs.
                </Typography>
                <br />
                <Typography>
                    This field is required and can be up to 50 characters.
                </Typography>
            </>
        ),
    },
    CARRIER_FROM: {
        name: 'carrierFrom',
        descriptor: {
            isRequired: true,
            format: '^.+$',
            min: 2,
            max: 26,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_484/v1622813476/GCG/smb_assets/gcg_carrier_example_fukmht',
        infoText: (
            <>
                <Typography>
                    The carrier is the sheet of paper that the card is affixed
                    to. It contains information on how to activate and use the
                    attached card.
                </Typography>
                <br />
                <Typography>
                    On the carrier, you can specify the “From:” field so the
                    recipient knows who the card is from. In most cases, this
                    will be your business name, but it doesn’t have to - you’re
                    free to put an appropriate value here to meet your needs.
                </Typography>
                <br />
                <Typography>
                    This field is required and can be up to 26 characters.
                </Typography>
            </>
        ),
    },
    CARRIER_MESSAGE: {
        name: 'carrierMessage',
        descriptor: {
            isRequired: true,
            format: '^.+$',
            min: 2,
            max: 120,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_484/v1622813476/GCG/smb_assets/gcg_carrier_example_fukmht',
        infoText: (
            <>
                <Typography>
                    The carrier is the sheet of paper that the card is affixed
                    to. It contains information on how to activate and use the
                    attached card.
                </Typography>
                <br />
                <Typography>
                    On the carrier, you can specify the “Message:” field so the
                    recipient has context for why they are receiving the card.
                    In some cases this will be congratulatory, thank you for
                    business, appreciation, or another reward context, but it
                    doesn’t have to - you’re free to put an appropriate value
                    here to meet your needs.
                </Typography>
                <br />
                <Typography>
                    This field is required and can be up to 120 characters.
                </Typography>
            </>
        ),
    },
    SHIP_TO: {
        name: 'address',
        descriptor: {
            isRequired: true,
        },
    },
}

export const DIGITAL_ATTRIBUTES = {
    AMOUNT: {
        name: 'amount',
        descriptor: {
            isRequired: true,
            min: 10,
            max: 500,
        },
    },
    FIRST_NAME: {
        name: 'firstName',
        descriptor: {
            isRequired: true,
            min: 1,
            max: 30,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_398/v1622816742/GCG/smb_assets/gcg_example_delivery_email_ouuyld',
        infoText: (
            <>
                <Typography>
                    This is the first name of the recipient of your
                    virtual/egift card.
                </Typography>
                <br />
                <Typography>
                    Typically this is a person's first name, but if you want
                    your card to be anonymous, you can use phrases such as
                    "Good" and "Job" or "Thank" and "You" as the first name.
                </Typography>
            </>
        ),
    },
    LAST_NAME: {
        name: 'lastName',
        descriptor: {
            isRequired: true,
            min: 1,
            max: 30,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_398/v1622816742/GCG/smb_assets/gcg_example_delivery_email_ouuyld',
        infoText: (
            <>
                <Typography>
                    This is the last name of the recipient of your virtual/egift
                    card.
                </Typography>
                <br />
                <Typography>
                    Typically this is a person's last name, but if you want your
                    card to be anonymous, you can use phrases such as "Good" and
                    "Job" or "Thank" and "You" as last name.
                </Typography>
            </>
        ),
    },
    EMAIL_MESSAGE: {
        name: 'emailMessage',
        descriptor: {
            isRequired: true,
            min: 1,
            max: 150,
        },
        infoImage:
            'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_529,h_398/v1622816742/GCG/smb_assets/gcg_example_delivery_email_ouuyld',
        infoText: (
            <>
                <Typography>
                    When we deliver the virtual/egift card to the recipient, the
                    email will have a custom message field.
                </Typography>
                <br />
                <Typography>
                    You can use this to provide more information or longer
                    messaging to the recipient.
                </Typography>
                <br />
                <Typography>
                    This field is required and can be up to 150 characters long.
                </Typography>
            </>
        ),
    },
    EMAIL_ADDRESS: {
        name: 'emailAddress',
        descriptor: {
            isRequired: true,
            format: '(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$)',
            min: 5,
            max: 254,
        },
    },
}

export const validLength = (attribute, value) => {
    const { min, max } = attribute.descriptor
    let isValidLength
    const valueString = trim(String(value))
    isValidLength = valueString.length >= min && valueString.length <= max
    return isValidLength
}

export const validFormat = (attribute, value) => {
    const { format } = attribute.descriptor
    let isValidFormat = true
    if (format) {
        isValidFormat = String(value).match(format)
    }
    return isValidFormat
}

export const isValid = (attribute, params, allowEmpty = true) => {
    const { value } = params

    // Treat unset values as OK until entered
    if (allowEmpty === true && isEmpty(value)) {
        return true
    }

    // If the field isn't required and it's not set, that's OK
    if (
        isEmpty(trim(value)) &&
        get(attribute, 'descriptor.isRequired', null) === false
    ) {
        return true
    }

    if (attribute && value) {
        return validLength(attribute, value) && validFormat(attribute, value)
    }
}

export const isValueValid = (selectedProduct, params) => {
    const { product } = selectedProduct

    const value = parseFloat(params.value)
    const minDenomination = parseFloat(product.min_load_value)
    const maxDenomination = parseFloat(product.max_load_value)

    return value >= minDenomination && value <= maxDenomination
}
